<template lang="pug">
include /mixins

+b.ti-stripe-view(
  style='padding: 20px'
)
  v-caption(size='5' variant='bold' style='padding-bottom: 20px') {{ _("c Stripe payment") }}
  +e.content
    +e.loader
    +e.form
      form#payment-form.form-loader
        #error-message
        #payment-element
          // Elements will create form elements here
        div#payment-request-button
        +e.button
          .card__panel.card__panel--offset_bottom
            +b.row--justification_end
              +b.cell.cols--12.--6-sm.--12-md.--6-xl
                +b.control-button--variant_success.--border_whole.BUTTON#submit(
                  style='margin-top: 12px'
                  type='submit'
                )
                  +e.element--size_lg
                    +b.caption--size_4.--variant_bold.SPAN {{ _('Pay now') }}

</template>

<script>

import Checkbox from '@cabinet/components/forms/blocks/Checkbox'
import { mapState } from 'vuex'
import { successHandler, errorHandler } from '@cabinet/util'
import { Card, createToken } from 'vue-stripe-elements-plus'
import AutocompleteMixin from './../../../mixin/AutocompleteMixin'
import StripeBtn from '@cabinet/components/forms/StripeBtn'

import OrdersService from '@cabinet/services/api/orders'
import PaymentsService from '@cabinet/services/api/payments'
import UiSelect from '@cabinet/components/forms/blocks/UiSelect'
import UiCreditCardView from '@cabinet/components/forms/UiCreditCardView'

import StripePayment from '@cabinet/packages/stripe/src/main'
// import StripePayment from '@cabinet/packages/stripe/src/main'

export default {
  components: {
    UiCreditCardView,
    Checkbox,
    StripeCard: Card,
    StripeBtn,
    UiSelect,
  },

  props: {
    dataInfo: {
      type: Object
    },
    formData: {
      type: Object
    },
    totalPrice: {
      required: true
    },
    currency: {
      required: false,
      default: 'USD'
    },
    order: {},
    redirect: {},
    promise: {},
  },
  data() {
    return {
      complete: false,
      loading: false,

    }
  },
  async mounted() {

    this.createIntent()
  },
  computed: {
    ...mapState('userModule', ['userData']),
    totalPriceConverted() {
      return parseFloat(this.totalPrice) * 100
    }
  },
  watch: {
    complete: {
      handler(val) {
        // if (val) {
        //   this.loading = true
        //   createToken(this.dataInfo.token)
        //     .then(data => {
        //       console.log(data)
        //       this.loading = false
        //       if (data.token) {
        //         this.disablePayment = false
        //         this.formData.stripe_token = data.token.id
        //       }
        //     })
        //     .catch(() => {
        //       this.disablePayment = false
        //     })
        // } else {
        //   this.disablePayment = true
        // }
      }
    },
  },
  methods: {
    createIntent() {
      PaymentsService.createIntent(
        {
          currency: this.currency == "CA$" ? 'CAD' : 'USD', 
          amount: this.order.price, 
          payment_parameters: {
            setup_future_usage: 'off_session',
            automatic_payment_methods: { enabled: true },
            confirm: false,
            payment_method_options: {
              'card': {
                'setup_future_usage': 'off_session',
              },
            }, 
          } ,
          "automatic_payment_methods": [
            "card",
          ],
          referer: window.location.href,
        }
      ).then(({ data: { client_secret, payment } } ) => {
        this.stripeInstance = new StripePayment(this.order.price, this.dataInfo.token, client_secret, this.order.id, 'payment-form', payment, this.redirect, {...this.formData, ...this.dataInfo})
        if (this.only_secure) {
          this.stripeInstance.loadSecureScript(this.order)
          this.opened = true
          return 
        }
        this.stripeInstance.loadScript()
        this.stripeInstance.complete()
        
        this.opened = true
      }, err => {
        const e = document.getElementById('error-message')
        console.log(e, err.response);
        if (e) {
          e.textContent = err.response.data.error
        }
        const p = document.getElementById('submit')
        p.style.display = 'none'
        const pf = document.getElementById('payment-form')
        pf.classList.remove('form-loader')
        

      })
    },
    async submit() {
      if (!this.invisibleCaptcha) {

        this.$refs.observer.validate().then(result => {

          if (result) {
            this.loading = true
            /*if address from autocomplete*/
            if (this.billingAddress.place_id) this.formatAddress()
            let form = this.transform(JSON.parse(JSON.stringify(this.formData)))
            /* delete unnecessary fields in*/
            if (form.billing_address) {
              delete form.billing_address.route
              delete form.billing_address.streetNumber
            }
            OrdersService.updateCurrent({ info: form })
              .then(res => {
                console.log(res)
                successHandler(res.data)
                this.loading = false
                this.formData.authorize.code = ''
                this.formData.authorize.number = ''
                this.formData.authorize.date = ''
                this.$refs.observer.reset()
              })
              .catch(err => {
                //(err)
                this.loading = false
                console.error(err)
                let { data: errors } = err.response
                errorHandler(errors.errors, this.$refs.observer, err.response, this)
              })
          }
        })
      }
    },
    transform(data) {
      let form = { ...data }
      if (form.payment === 'authorize') {
        let date = form.authorize.date.split('/')
        date = [`20${date[1]}`, date[0]].join('-')
        form.authorize.date = date
      } else {
        delete form.authorize
      }
      if (form.payment === 'apple-id') {
        delete form.billing_address
      }
      if (form.payment !== 'stripe') {
        delete form.stripe_token
      }
      if (form.payment === 'cash') {
        form = {}
      }
      return form
    },
    async succesAppleAction(event) {
      try {
        this.loading = true
        const result = (await OrdersService.appPay({ id: event.paymentIntent.id }))
        successHandler(result.data)
        this.loading = false
      } catch (error) {
        this.loading = false
        console.error(error)
        let { data: errors } = error.response
        errorHandler(errors.errors, this.$refs.observer, error.response, this)
      }
    },
    fillAddress() {
      const data = this.formData.billing_address
      if (
        data.zipcode
        && data.subdivision
        && data.city
        && data.address_line_1
        && data.country
      ) {
        let addresString = `${data.address_line_1}, ${data.city}, ${data.subdivision}, ${data.country}, ${data.zipcode}`
        this.billingAddress = { description: addresString }
        const address = this.formData.billing_address.address_line_1
        /*to prevent validation error on prefilled address.
        street number and route keep separately*/
        const streetNumberRegExp = /\d{1,}\s/
        const streetNumberEntry = address.match(streetNumberRegExp)
        if (null !== streetNumberEntry && 0 === streetNumberEntry.index) {
          const [streetNumber] = streetNumberEntry
          this.formData.billing_address.streetNumber = streetNumber.trim()
          this.formData.billing_address.route = address.slice(streetNumber.length, address.length)
        } else {
          this.formData.billing_address.route = address
        }
      }
    },
    formatAddress() {
      this.formData.billing_address.address_line_1 = `${this.formData.billing_address.streetNumber} ${this.formData.billing_address.route}`
    }
  }
}
</script>
